import './App.css';

import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { MainPageNavbar } from './Components/MainPageNavbar';
import { Footer } from './Components/Footer';
import { WorkContent } from './Components/WorkContent';
import { HobbiesContent } from './Components/HobbiesContent';
import { FloatingBackground } from './Components/FloatingBackground';

import { AboutPageNavbar } from './Components/AboutPageNavbar';
import { AboutContent } from './Components/AboutContent';
import { Placeholder } from './Components/Placeholder';

function App() {
  const [activeTab, setActiveTab] = useState('work');

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div className="App">
        <FloatingBackground />
        <Routes>
          <Route
            path="/"
            element={
              <main className="page">
                <MainPageNavbar activeTab={activeTab} setActiveTab={setActiveTab} />
                {activeTab === 'work' ? <WorkContent /> : <HobbiesContent />}
              </main>
            }
          />
          <Route
            path="/about"
            element={
              <main className="page">
                <AboutPageNavbar />
                <AboutContent />
              </main>
            }
          />
          <Route
            path="/financialsystem"
            element={
              <main className="page">
                <AboutPageNavbar />
                <Placeholder />
              </main>
            }
          />
          <Route
            path="/3dprinting"
            element={
              <main className="page">
                <AboutPageNavbar />
                <Placeholder />
              </main>
            }
          />
          <Route
            path="/mealprep"
            element={
              <main className="page">
                <AboutPageNavbar />
                <Placeholder />
              </main>
            }
          />
          <Route
            path="/keyboards"
            element={
              <main className="page">
                <AboutPageNavbar />
                <Placeholder />
              </main>
            }
          />
          <Route
            path="*"
            element={
              <main className="page">
                <AboutPageNavbar />
                <div className="error">
                  <div>
                    <h1 className="section-heading">404</h1>
                    <p className="section-subtitle">This page does not exist yet.</p>
                  </div>
                </div>
              </main>
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
